import type { Tour } from '../../types';

export const analyticsTour: Tour = {
  id: 'platform-analytics',
  name: 'Analytics Tour',
  description: 'Learn how to use platform analytics and reporting',
  category: 'platform',
  showProgress: true,
  requiredPath: '/platform/analytics',
  steps: [
    {
      id: 'analytics-1',
      target: 'analytics-header',
      title: 'Platform Analytics',
      content: 'Monitor the health and usage of the entire OHCS Document Management platform. Analyze trends across all MDAs.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'analytics-2',
      target: 'analytics-overview',
      title: 'Platform Overview',
      content: 'Key metrics at a glance: total documents, active users, storage usage, and system uptime across all MDAs.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'analytics-3',
      target: 'analytics-mda-comparison',
      title: 'MDA Comparison',
      content: 'Compare activity levels across MDAs. Identify which institutions are most active and which may need attention.',
      position: 'right',
      spotlight: true,
    },
    {
      id: 'analytics-4',
      target: 'analytics-usage-trends',
      title: 'Usage Trends',
      content: 'View historical trends for document creation, user logins, and workflow completions. Identify patterns and seasonal variations.',
      position: 'right',
      spotlight: true,
    },
    {
      id: 'analytics-5',
      target: 'analytics-storage',
      title: 'Storage Analytics',
      content: 'Monitor storage consumption across MDAs. Plan capacity and identify opportunities to archive or clean up old data.',
      position: 'left',
      spotlight: true,
    },
    {
      id: 'analytics-6',
      target: 'analytics-export',
      title: 'Export Reports',
      content: 'Generate detailed reports in PDF or Excel format. Schedule automatic report delivery to stakeholders.',
      position: 'left',
      spotlight: true,
      actionLabel: 'Finish Tour',
    },
  ],
};
